import MENV from '../env'
const ENV = MENV()

export const apiUrl =  ENV.SERVICE_API;
